<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div
        class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between"
    >
        <h5 class="mb-0">
            {{ t("evidences-list") }}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{ t("Assessments") }}
            </li>
            <li class="breadcrumb-item position-relative">
                <a
                    routerLink="/vulnerability/assessments"
                    class="d-inline-block position-relative"
                >
                    {{ t("Management") }}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                <a
                    routerLink="/vulnerability/view-vulnerabilities/{{
                        vulnerabilityAssessmentId
                    }}"
                    class="d-inline-block position-relative"
                >
                    {{ t("Vulnerabilities") }}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                {{ t("evidences-list") }}
            </li>
        </ol>
    </div>
    @if (isLoadingResults || isRateLimitReached) {
        <div class="loading-shade">
            @if (isLoadingResults) {
                <mat-spinner></mat-spinner>
            }
            @if (isRateLimitReached) {
                <div class="rate-limit-reached">
                    ALTAIR rate limit has been reached. It will be reset in one
                    minute.
                </div>
            }
        </div>
    }
    <!-- Evidences -->
    <mat-card
        class="altair-card companies-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()"
    >
        <mat-card-header>
            <mat-card-title>
                <form class="search-box position-relative">
                    <i class="material-symbols-outlined"> search </i>
                    <input
                        matInput
                        class="input-search d-block w-100 border-none outline-0"
                        placeholder="{{ t('search') }} {{ t('evidence') }}..."
                        (keyup)="applyFilter($event)"
                        (keydown.enter)="onKeydown($event)"
                        #input
                    />
                </form>
            </mat-card-title>
            <mat-card-title>
                @if (vulnerabilityAssessment) {
                    {{ vulnerabilityAssessment.branchOffice.company.name }} -
                    {{ vulnerabilityAssessment.assessmentName }}
                }
            </mat-card-title>
            <mat-card-subtitle>
                @if (roleName == internal) {
                    <button
                        mat-flat-button
                        class="altair"
                        (click)="toggleClass()"
                    >
                        {{ t("add-new-evidence") }}
                    </button>
                }
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div class="companies-table">
                <div class="table-responsive">
                    <table
                        mat-table
                        [dataSource]="dataSource"
                        matSort
                        matSortActive="label"
                        matSortDisableClear
                        matSortDirection="asc"
                    >
                        <!-- Label Column -->
                        <ng-container matColumnDef="label">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                {{ t("label") }}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <textarea matInput type="text" readonly="true" class="textarea-input"
                                    [value]="row.label"></textarea>
                            </td>
                        </ng-container>

                        <!-- Filename Column -->
                        <ng-container matColumnDef="filename">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                {{ t("filename") }}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{ cleanFileName(row.filename).cleanedName }}
                            </td>
                        </ng-container>

                        <!-- Type Column -->
                        <ng-container matColumnDef="type">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                {{ t("type") }}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <a
                                    mat-button
                                    href="{{ row.evidenceUrl }}"
                                    target="_blank"
                                    matTooltip="{{ t('view') }} {{
                                        t('evidence')
                                    }}"
                                    matTooltipPosition="above"
                                >
                                    <img
                                        src="assets/images/icons/{{
                                            cleanFileName(row.filename)
                                                .extension
                                        }}.png"
                                        width="50%"
                                        height="50%"
                                        alt="{{
                                            cleanFileName(row.filename)
                                                .extension
                                        }}"
                                    />
                                </a>
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ t("action") }}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div class="action-info">
                                    @if (roleName == internal) {
                                        <button
                                            type="button"
                                            mat-button
                                            (click)="edit(row.id)"
                                            matTooltip="{{ t('edit') }} {{
                                                t('evidence')
                                            }}"
                                            matTooltipPosition="above"
                                        >
                                            <i
                                                class="material-symbols-outlined"
                                            >
                                                edit
                                            </i>
                                        </button>
                                        <button
                                            type="button"
                                            mat-button
                                            (click)="delete(row.id)"
                                            matTooltip="{{ t('delete') }} {{
                                                t('evidence')
                                            }}"
                                            matTooltipPosition="above"
                                        >
                                            <i
                                                class="material-symbols-outlined"
                                            >
                                                delete
                                            </i>
                                        </button>
                                    }
                                </div>
                            </td>
                        </ng-container>

                        <tr
                            mat-header-row
                            *matHeaderRowDef="displayedColumns"
                        ></tr>
                        <tr
                            mat-row
                            *matRowDef="let row; columns: displayedColumns"
                        ></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">
                                {{ t("no-data-matching") }} "{{ input.value }}"
                            </td>
                        </tr>
                    </table>
                </div>
                <mat-paginator
                    [length]="totalItems"
                    [pageSizeOptions]="pageSizes"
                    showFirstLastButtons
                ></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>

    <!-- Popup -->
    <div
        class="add-new-evidence-popup"
        [class.active]="classApplied"
        [class.rtl-enabled]="themeService.isRTLEnabled()"
    >
        <div class="popup-dialog">
            <mat-card
                class="altair-card mb-25 border-radius bg-white border-none d-block"
            >
                <mat-card-header>
                    <mat-card-title>
                        <h5 class="mt-0 mb-0">
                            @if (!evidenceId) {
                                {{ t("add") }} {{ t("evidence") }}
                            } @else {
                                {{ t("edit") }} {{ t("evidence") }}
                            }
                        </h5>
                    </mat-card-title>
                    <mat-card-subtitle>
                        <button mat-button (click)="toggleClass()">
                            <i class="ri-close-fill"></i>
                        </button>
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <form [formGroup]="addEvidenceForm">
                        <div class="row">
                            <div class="col-md-12">
                                <label
                                    class="main-label d-block lh-1 text-black"
                                >
                                    {{ t("label") }}
                                </label>
                                <mat-form-field class="textarea">
                                    <mat-label>
                                        {{ t("enter-label") }}
                                    </mat-label>
                                    <textarea
                                        matInput
                                        type="text"
                                        id="label"
                                        formControlName="label"
                                        required
                                    ></textarea>
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label
                                    class="main-label d-block lh-1 text-black"
                                >
                                    {{ t("order") }}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{ t("enter-order") }}
                                    </mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        id="order"
                                        formControlName="order"
                                    />
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('upload-file')}} @if (!evidenceId) {<span>*</span>}
                                    <span class="text-muted">({{t('accepted-formats')}}: .gif, .jpg, .png,
                                        .zip)</span>
                                </label>
                                <file-upload class="file-uploader" multiple="false" accept=".gif,.jpg,.png,.zip"
                                    formControlName="file" [control]="fileControl"></file-upload>
                                <mat-error *ngIf="addEvidenceForm.get('file')!.hasError('required')">
                                    {{t('field-required')}}
                                </mat-error>
                            </div>
                        </div>
                        <div class="btn-box">
                            <button
                                mat-button
                                type="button"
                                (click)="
                                    !evidenceId ? addEvidence() : editEvidence()
                                "
                                [disabled]="
                                    addEvidenceForm.invalid || isWorking
                                "
                            >
                                {{ t("save") }} {{ t("evidence") }}
                            </button>
                            <button mat-button (click)="toggleClass()">
                                {{ t("cancel") }}
                            </button>
                        </div>
                    </form>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</ng-container>
